import React from "react"
import {observer} from "mobx-react"
import {injectIntl} from "react-intl"

import {Container, Grid} from "@material-ui/core" // Link, Typography

function XsFooter() {
	// const [srcMHSRLogo, setSrcMHSRLogo] = useState("/public/images/mhsr_logo_white.png")
	// const [srcSIEALogo, setSrcSIEALogo] = useState("/public/images/logo_siea_white.png")

	return (
		<div className="main_footer">
			<footer className="first_part">
				<div className="border_top"></div>
				<Container maxWidth="lg" className="footer_container">
					<Grid container justify="space-between" alignItems="center">
						{/* <Grid item container xs alignItems="center">
							<Grid item>
								<img
									className="pointer"
									src={srcSIEALogo}
									onMouseOver={() => setSrcSIEALogo("/public/images/logo_siea_blue.png")}
									onMouseOut={() => setSrcSIEALogo("/public/images/logo_siea_white.png")}
									onClick={() => window.open("https://www.siea.sk/", "_blank")}
								/>
							</Grid>
							<Grid item style={{color: "rgba(0, 0, 0, 0.48)"}}>
								<Box ml={4}>
									<Grid container direction="column" spacing={1}>
										<Grid item>Bajkalská 27</Grid>
										<Grid item>827 99 Bratislava</Grid>
									</Grid>
								</Box>
							</Grid>
						</Grid> */}
						<Grid item>
							<img style={{height: "45px"}} src="/public/images/footerLogo1.svg" />
						</Grid>
						<Grid item>
							<img style={{height: "45px"}} src="/public/images/footerLogo2.svg" />
						</Grid>
						<Grid item>
							<img style={{height: "45px"}} src="/public/images/footerLogo3.svg" />
						</Grid>
					</Grid>
				</Container>
			</footer>
			{/* <footer className="second_part white">
				<Container maxWidth="lg" className="footer_container">
					<Typography variant="caption">
						<Grid container>
							<Grid item>
								© 2021 SIEA&nbsp;&nbsp;|&nbsp;&nbsp;<i className="fal fa-envelope"></i>&nbsp;
								<Link className="white" href="mailto:inovacnepoukazky@siea.gov.sk">
									inovacnepoukazky@siea.gov.sk
								</Link>
								&nbsp;&nbsp;|&nbsp;&nbsp;
								<Link
									className="white pointer"
									onClick={() => window.open("https://www.siea.sk/o-siea/ochrana-osobnych-udajov/", "_blank")}
								>
									GDPR
								</Link>

							</Grid>
							<Grid item className="pl-4">
								Created: 2021 | Changed: 2021
							</Grid>
						</Grid>
					</Typography>
				</Container>
			</footer> */}
		</div>
	)
}

export default injectIntl(observer(XsFooter))

